module.exports = __webpack_public_path__ + "static/img/041 3.3d6269fb.jpg";